import { useQuery } from 'react-query';
import ActivityService from '../../../services/ActivityService';
import { ACTIVITY } from '../../constants/queryDefinition';
import LOCALSTORAGE from '../../constants/localStorage';

const activityService = ActivityService.get();
const MAX_PAGE_SIZE = 1000;

const useEtrPaymentsOnHoldTradeList = options => {
  const queryEtrPaymentOnHoldSearchList = async () => {
    const selectedDealer = JSON.parse(
      localStorage.getItem(LOCALSTORAGE.OMP_SELECTED_DEALER) || '{}'
    );
    const organizationId = selectedDealer?.organizationId;
    const etrServiceResponse = await activityService.getEtrPaymentsOnHoldSearchList(
      {
        organizationIds: [organizationId],
        pageSize: MAX_PAGE_SIZE
      }
    );
    return etrServiceResponse;
  };

  const { data, refetch } = useQuery(
    [ACTIVITY.GET_ETR_PAYMENT_ON_HOLD_TRADE_LIST.KEY],
    queryEtrPaymentOnHoldSearchList,
    {
      staleTime: ACTIVITY.GET_ETR_PAYMENT_ON_HOLD_TRADE_LIST.STALE_TIME,
      cacheTime: ACTIVITY.GET_ETR_PAYMENT_ON_HOLD_TRADE_LIST.STALE_TIME,
      enabled: options?.isMergedPaymentsOnHoldEnabled,
      retry: false
    }
  );

  return {
    etrPaymentsOnHold: data?.data,
    refetchEtrPaymentsOnHold: refetch
  };
};

export default useEtrPaymentsOnHoldTradeList;
